"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableSort = void 0;
const user_settings_context_1 = require("../../../settings/user/user-settings-context");
const react_1 = require("react");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const update_effect_1 = require("../../../utils/update-effect");
function useTableSort({ tableId, version, columns, defaultSorts, }) {
    const { getTableSettings, setTableSettings } = (0, react_1.useContext)(user_settings_context_1.UserSettingsContext);
    let settings;
    let initSorts = defaultSorts;
    if (tableId !== '') {
        settings = getTableSettings(tableId, version);
        if ((settings === null || settings === void 0 ? void 0 : settings.sorts) !== undefined) {
            initSorts = settings === null || settings === void 0 ? void 0 : settings.sorts;
        }
    }
    const [sorts, setSorts] = (0, react_1.useState)(initSorts);
    const toggleSortColumn = (0, event_callback_hook_1.useEventCallback)((datakey) => {
        var _a, _b;
        const sortIndex = sorts.findIndex((sort) => sort.datakey === datakey);
        if (sortIndex === -1) {
            const column = columns.find((column) => column.datakey === datakey);
            setSorts([
                ...sorts,
                {
                    datakey,
                    field: (_a = column === null || column === void 0 ? void 0 : column.sortkey) !== null && _a !== void 0 ? _a : datakey,
                    order: 'ASC',
                    type: (_b = column === null || column === void 0 ? void 0 : column.sortType) !== null && _b !== void 0 ? _b : 'FIELD',
                },
            ]);
        }
        else {
            const sort = sorts[sortIndex];
            if (sort.order === 'ASC') {
                setSorts([
                    ...sorts.slice(0, sortIndex),
                    {
                        ...sort,
                        order: 'DESC',
                    },
                    ...sorts.slice(sortIndex + 1, undefined),
                ]);
            }
            else {
                setSorts([
                    ...sorts.slice(0, sortIndex),
                    ...sorts.slice(sortIndex + 1, undefined),
                ]);
            }
        }
    });
    const resetSorts = (0, event_callback_hook_1.useEventCallback)(() => {
        setSorts(defaultSorts);
    });
    /**
     * Updates user settings.
     */
    (0, update_effect_1.useUpdateEffect)(() => {
        const newSettings = {
            ...(settings !== null && settings !== void 0 ? settings : {}),
            sorts,
            version,
        };
        setTableSettings(tableId, newSettings);
    }, [sorts]);
    return { sorts, setSorts, toggleSortColumn, resetSorts };
}
exports.useTableSort = useTableSort;
//# sourceMappingURL=table-sort-hook.js.map